import React from 'react';
import IntroHome from './IntroHome';
import QuoteHome from './QuoteHome';
import ApproachHome from "./ApproachHome";
import ContactHome from './ContactHome';
import NewsHome from './NewsHome';
import RightsHome from './RightsHome';

export default function Home() {
  return (
    <>
      <IntroHome />
      <ApproachHome />
      <RightsHome />
      <NewsHome />
      <ContactHome />
    </>
  )
}
